export default __webpack_public_path__ + "c503d1d529d2f6b64559b351bcf391c0.webp";